export default __webpack_public_path__ + "static/media/Chiefs.cc2b12ca.png";